module.exports = __webpack_public_path__ + "img/img2.af95c0a7.svg";